// extracted by mini-css-extract-plugin
export default {"wrapper":"UnAuthLayout_wrapper__SvGP-"};